// React
import { useState, useEffect } from 'react'

import AlgoliaSearch from './AlgoliaSearch'

export default function RetailerSelect({
    onSelect,
    placeholder = 'Rechercher un revendeur Shopify...',
    label,
}) {
    return (
        <>
            <AlgoliaSearch
                algolia_index="engine_retailers"
                placeholder={placeholder}
                onSelect={onSelect}
                label={label}
            />
        </>
    )
}
